import { ModalFactory } from '@vend/vend.ui'
import angular from 'angular'

import { QuickKeyNodeType } from '../qk.constants'
import { getProductDetails } from '../qk-layout'
import { QuickKey } from '../qk-types'
import template from './edit-quick-key.html'

/**
 * Service for opening modals related to editing quick keys, folders, etc.
 *
 * @module vendQuickKeys.qkModals
 */
angular
  .module('vendQuickKeys')
  .service('qkModals', function (this: $TSFixMe, Modal: ModalFactory) {
    /**
     * Open the "Edit quick key" modal that allows the user to edit the name, colour, etc or delete a given quick key.
     *
     * @method editQuicKey
     *
     * @param  {QuickKeysLayout} layout
     *         The layout model for the button layout the given quick key belongs to
     *
     * @param  {QuickKey} quickKey
     *         The quick key to edit
     */
    this.editQuicKey = function (layout: $TSFixMe, quickKey: QuickKey) {
      Modal({
        template,
        dismissible: true,
      }).then(modal => {
        const ctrl = modal.controller

        ctrl.layout = layout
        ctrl.isQuickKey = quickKey.type === QuickKeyNodeType.QUICK_KEY
        ctrl.displayQuickKeyType = ctrl.isQuickKey ? 'Quick Key' : 'Folder'
        function toggleWaitingForServer(isAwaitingServer: $TSFixMe) {
          modal.scope.$applyAsync(() => {
            ctrl.awaitingServer = isAwaitingServer
          })
        }

        if (ctrl.isQuickKey) {
          ctrl.loadingProductInfo = true

          // Attempt to load details for the quick key product
          layout
            .getProduct(quickKey)
            .then((productDetails: $TSFixMe) => {
              if (productDetails) {
                const { isChild } = getProductDetails(quickKey)

                ctrl.productName = isChild
                  ? productDetails.variant_name
                  : productDetails.name

                if (!productDetails.has_variants || isChild) {
                  ctrl.productSku = productDetails.sku
                }
              }
            })
            .finally(() => {
              ctrl.loadingProductInfo = false
            })
        }

        // Clone the original quickKey so we can discard changes if the user cancels the modal
        ctrl.quickKey = angular.copy(quickKey)
        ctrl.awaitingServer = false
        ctrl.changeColour = (colour: $TSFixMe) => {
          modal.scope.$applyAsync(() => {
            ctrl.quickKey.viewData.color = colour
          })
        }

        ctrl.saveChanges = function () {
          toggleWaitingForServer(true)
          layout.updateQuickKey(ctrl.quickKey).finally(() => ctrl.close!())
        }

        ctrl.deleteQuickKey = function () {
          toggleWaitingForServer(true)
          layout.deleteQuickKey(quickKey).finally(() => ctrl.close!())
        }
        modal.scope.$watch(
          'modalCtrl.awaitingServer',
          (awaitingServer: $TSFixMe) => {
            ctrl.dismissible = !awaitingServer
          }
        )
      })
    }
  })
